(() => {
  let scheduled = false;

  const getDrawer = () => document.querySelector('#cart-drawer');

  const setText = (root, selector, text) => {
    const el = root.querySelector(selector);
    if (el && el.textContent.trim() !== text) el.textContent = text;
  };

  const updateDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;

    const empty = drawer.querySelector('.cart-drawer--empty');
    if (empty) {
      setText(drawer, '.cart-drawer--empty .theme-drawer__title', 'Je winkelwagen is leeg');
      setText(drawer, '.cart-items__empty-button .button-text', 'Verder winkelen');
      return;
    }

    setText(drawer, '.theme-drawer__title', 'Winkelwagen');
    setText(drawer, '.cart-discount__label', 'Korting');
    setText(drawer, '.cart-totals__total-label', 'Geschat totaal');
    setText(drawer, '.cart__checkout-button .button-text', 'Afrekenen');
    setText(drawer, '.cart-discount__button', 'Toepassen');

    const discountInput = drawer.querySelector('.cart-discount__input');
    if (discountInput) discountInput.placeholder = 'Kortingscode';

    const taxNote = drawer.querySelector('.cart-totals__tax-note');
    if (taxNote && taxNote.textContent.trim() !== 'Verzendkosten worden berekend bij het afrekenen.') {
      taxNote.textContent = 'Verzendkosten worden berekend bij het afrekenen.';
    }

    drawer.querySelectorAll('.bbq-cart-crosssell').forEach((el) => el.remove());
  };

  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateDrawer();
    });
  };

  const init = () => {
    updateDrawer();
    const root = document.body || document.documentElement;
    if (!root || root.dataset.bbqCartObserver === 'true') return;
    root.dataset.bbqCartObserver = 'true';
    new MutationObserver(scheduleUpdate).observe(root, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scheduleUpdate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();